import axios from "axios";
import { Dispatch } from "redux";
import { toast } from "@teamprevent/common/toasts";
import { loadAndTrack } from "redux-request-loading";
import {
    SUBMIT_QUESTIONNAIRE,
    submitQuestionnaireSuccess,
    submitInvalidQuestionnaire,
    questionnaireLoaded,
}    from "@teamprevent/common/questionnaires/actions";

import { AnsweredQuestionWithId } from "@teamprevent/common/questionnaires/model";

import { GenericCaseFormApi } from "./genericCaseFormApi";
import { LOAD_GENERIC_CASE_FORM } from "./actionTypes";

export const submitQuestionnaire = buildSubmitQuestionnaire(new GenericCaseFormApi(axios));

export function buildSubmitQuestionnaire(genericCaseFormApi: GenericCaseFormApi) {
    return (questions: AnsweredQuestionWithId[], questionnaireKey: string) => {
        if (!questions.every(question => question.isValid)) {
            return (dispatch: Dispatch) => dispatch(submitInvalidQuestionnaire(questionnaireKey, true));
        }
        return async (dispatch: Dispatch) => {
            await loadAndTrack(dispatch, SUBMIT_QUESTIONNAIRE, genericCaseFormApi.submit(questions));
            toast.success("Form submitted successfully");
            dispatch(submitQuestionnaireSuccess(questionnaireKey));
        };
    };
}

export const loadLoadGenericCaseForm = buildLoadGenericCaseForm(new GenericCaseFormApi(axios));

export function buildLoadGenericCaseForm(genericCaseFormApi: GenericCaseFormApi) {
    return (ohCaseId: string, questionnaireKey: string) => {
        return async (dispatch: Dispatch) => {
            const response = await loadAndTrack(dispatch, LOAD_GENERIC_CASE_FORM, genericCaseFormApi.loadGenericCaseForm(ohCaseId));
            if (response && response.data) {
                const questions = response.data.questions;
                dispatch(questionnaireLoaded({ questions, questionnaireKey }));
            }
        };
    };
}
